import FormatItem from '@/assets/formats/format-item'

import CareerYagiofferCards from '@/assets/formats/career-yagioffer-cards'
import NewYagiofferCards from '@/assets/formats/new-yagioffer-cards'

import CareerYagiofferEdit from '@/components/formats/CareerYagiofferEdit'
import NewYagiofferEdit from '@/components/formats/NewYagiofferEdit'

// import ShokurekishoPreview from '@/components/formats/ShokurekishoPreviewSample'

const jobChangeExampleSentences = {
  // 志望動機
  reason: [
    {
      title: 'スキルアップのために転職したい',
      description:
        '前職ではX年間にわたってXX業務に携わってきました。貴社のXXについては以前から興味を感じており、XXな部分に大変魅力を感じます。今までの経験を活かしながら、さらにXXなどのスキルを身につけ、貴社におけるXX業務に貢献したいと考え志望しました。'
    },
    {
      title: '事業内容に関心がある',
      description:
        '貴社が取り組まれているXX事業に関心があり、応募いたしました。特にXXな点に非常に魅力的を感じています。これまでの私の経験を最大限活用しつつ、ぜひ貴社の一員としてその成長に関わりたいと考えております。'
    },
    {
      title: '自身の経験を活かしたい',
      description:
        '自分のXXXという経験・スキルを活かして貴社に貢献できると考え、この度応募いたしました。今までの経験を活かしながら新しい業務にもチャレンジし、貴社の事業や組織の成長に貢献しながら自分も成長したいと考えております。'
    },
    {
      title: '企業のビジョンに共感した',
      description:
        '貴社のXXXXという企業ビジョンに共感するものがあり、今回応募いたしました。私自身もXXXXという点を大切にしたいと考えており、そのようなビジョンを大切にしている方々と一緒に働きたいと考えております。'
    },
    {
      title: '裁量の大きさに魅力を感じた',
      description:
        '貴社の個々の裁量が大きい職場環境に対して魅力を感じ、今回応募いたしました。責任感を持ちながら、工夫を重ねて成果を出していく職場環境であるということに、自身が成長できる可能性と魅力を感じます。'
    },
    {
      title: '社員に魅力を感じた',
      description:
        '貴社で働かれている社員の方々をXXXXで拝見し、その働き方に魅力を感じて応募いたしました。その中でもXXXという点が、自身の価値観や仕事感に近いと感じました。XXXXを行うことで、貴社への価値貢献をしたいと考えております。'
    },
    {
      title: '未経験職種へ転職したい',
      description:
        '前職ではXXに従事しておりましたが、よりXXに貢献できるような仕事をしたいと考えておりました。今回、貴社のXX求人を拝見し自分もこのような環境で挑戦してみたいと考え、転職を決意致しました。'
    },
    {
      title: '一度離れた職種に戻りたい',
      description:
        '前職ではXX業務に携わり貴重な経験を得ましたが、もう一度XXに戻りたいという思いが強くなりこの度貴社を志望致しました。今までの実務経験の強みを活かしながら、新しい技術に関しても積極的に勉強していきたいと考えています。'
    }
  ],
  // 資格
  license: [
    { title: '自動車免許(MT車)', description: '普通自動車第一種運転免許取得' },
    {
      title: '自動車免許(AT限定)',
      description: '普通自動車第一種運転免許（AT限定）取得'
    },
    { title: '英検', description: '実用英語技能検定X級合格' },
    { title: 'TOEIC', description: 'TOEIC公開テストXXX点取得' },
    { title: 'TOEFL', description: 'iBTテストスコアX点取得' },
    { title: '日商簿記', description: '日商簿記検定試験X級合格' },
    {
      title: 'ファイナンシャルプランナー',
      description: 'ファイナンシャルプランナーX級合格'
    }
  ],
  // 本人希望欄
  request: [
    {
      title: '連絡可能な時間帯',
      description:
        '連絡可能な時間帯：電話の場合、平日18時以降または土日祝日。現在在職中のため、平日日中のご連絡についてはメールでお送り頂ければ幸いです。'
    },
    {
      title: '帰社時間の希望',
      description:
        '子供の保育園の迎えのため、毎週水曜日は18時に退勤させていただければ幸いです。'
    },
    { title: '希望職種', description: '希望職種：XX職を希望します。' },
    {
      title: '希望年収',
      description: '現在の年収はOOO万円です。希望年収はXXX万円となります。'
    },
    { title: '特に希望がない場合', description: '貴社規定に従います。' }
  ]
}

const licenseCommon = [
  { title: '原付免許', description: '原動機付自転車免許取得' },
  { title: '自動車免許', description: '普通自動車第一種運転免許取得' },
  {
    title: '自動車免許(AT限)',
    description: '普通自動車第一種運転免許(AT限定)取得'
  },
  { title: '英検', description: '実用英語技能検定X級合格' },
  { title: 'TOEIC', description: 'TOEIC公開テストXXX点取得' },
  { title: 'TOEFL', description: 'iBTテストスコアX点取得' },
  { title: '日商簿記', description: '日商簿記検定試験X級合格' },
  {
    title: 'ファイナンシャルプランナー',
    description: 'ファイナンシャルプランナーX級合格'
  }
]

const formatsIndex = [
  new FormatItem({
    // 転職用の履歴書（JIS規格）
    id: 'career',
    title: '転職者用のyagioffer登録',
    description:
      '令和２年７月からスタートした新様式です。日本工業規格（JIS）の規格に従ったA4サイズ2枚の一般的な履歴書テンプレートです。学歴・職歴の記入欄は比較的広めのつくりになっており、社会人経験が長い人にもおすすめです。',
    thumbnail: '/static/img/formats/rirekisho_job_change.png',
    images: [
      '/static/img/formats/sample/rirekisho_job_change_01.jpg',
      '/static/img/formats/sample/rirekisho_job_change_new_02.jpeg'
    ],
    newdetail1: 'A4サイズ/２枚',
    newdetail2: '令和２年７月からスタートした新様式',
    newdetail3: '社会人経験多めの方におすすめ',
    newdetail: '社会人経験多めの方向け',
    pagenumbs: '2枚',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email',
      'contact',
      'contactTel',
      'contactEmail',
      'photo'
    ],
    hashs: ['履歴書', '転職'],
    components: {
      edit: CareerYagiofferEdit
    },
    cards: CareerYagiofferCards,
    exampleSentences: jobChangeExampleSentences
  }),
  new FormatItem({
    // 新卒用の履歴書
    id: 'new',
    title: '新卒用のyagioffer登録',
    description:
      '一般的なA4サイズ2枚の新卒用履歴書テンプレートです。職歴欄がなく、学歴欄や志望動機・特技・アピールポイント・インターンシップなどを広めにしたレイアウトになっています。',
    thumbnail: '/static/img/formats/rirekisho_job_new.png',
    images: [
      '/static/img/formats/sample/rirekisho_job_new_01.png',
      '/static/img/formats/sample/rirekisho_job_new_02.png'
    ],
    newdetail1: 'A4サイズ/２枚',
    newdetail2: '職歴欄なし',
    newdetail3: '学歴・志望動機・アピール欄が広め',
    newdetail: '職歴欄なしでアピール欄広め',
    pagenumbs: '2枚',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email',
      'contact',
      'contactTel',
      'contactEmail',
      'photo'
    ],
    hashs: ['履歴書', '新卒', '学生'],
    components: {
      edit: NewYagiofferEdit
    },
    cards: NewYagiofferCards,
    exampleSentences: {
      // 志望動機
      reason: [
        {
          title: '業務内容に関心がある',
          description:
            '貴社が取り組まれているXX事業に関心があり、応募いたしました。特にXXな点に非常に魅力的を感じています。これまでの私の経験を最大限活用しつつ、ぜひ貴社の一員としてその成長に関わりたいと考えております。'
        },
        {
          title: '自身の経験を活かしたい',
          description:
            '自分のXXXという経験・スキルを活かして貴社に貢献できると考え、この度応募いたしました。今までの経験を活かしながら新しい業務にもチャレンジし、貴社の事業や組織の成長に貢献しながら自分も成長したいと考えております。'
        },
        {
          title: '企業のビジョンに共感した',
          description:
            '貴社のXXXXという企業ビジョンに共感するものがあり、今回応募いたしました。私自身もXXXXという点を大切にしたいと考えており、そのようなビジョンを大切にしている方々と一緒に働きたいと考えております。'
        },
        {
          title: 'インターンシップの経験を活かしたい',
          description:
            '実際に業務を体験してみて、作成した資料が分かりにくいと指摘を受けることがありました。どうすれば分かりやすい資料を作成できるか繰り返し試みました。自分にとって社会へ出た際の大きな課題であると気付く機会となり、自身が成長できる可能性を感じました。'
        },
        {
          title: '得意科目',
          description:
            '私の得意科目は数学です。難しい問題でも必ず正解があり、正解にたどり着いた時の達成感を感じることが好きです。また、難解な問題への取り組みを通して、根気強く物事を考えたり、書籍やインターネットで調べるなど多種の手段で解決する経験を積んできました。論理的な課題解決能力で貴社に貢献したいです。'
        },
        {
          title: 'ゼミ研究',
          description:
            '私が所属しているゼミでは、毎週課題テーマを設定し、研究結果を発表する機会があります。プレゼンテーションをするのは初めてだったので、当初は資料作成も発表もうまくできませんでした。経験を重ねることで、書籍や文献などから知識を得て資料にまとめたり、質問に対しての返答などができるようになっていきました。研究を通じて、物事を柔軟に考える重要性を学びました。'
        },
        {
          title: 'ボランティア活動',
          description:
            'XX震災後、私は復興支援活動としてXX地区の瓦礫撤去作業を行いました。チームリーダーを担当し、自分から率先して動いたり、周りに指示を出したりしながら活動しました。活動する中で、周りに指示を出すことの難しさや協力することの大切さを知りました。この経験で培ったリーダーシップや行動力を貴社で活かしたいと思っています。'
        },
        {
          title: '学生時代のアルバイト経験',
          description:
            '小売りのお店でアルバイトしていたことがあります。働いていたお店の売上が振るわない時期がありました。接客時に、同じ商品について複数回聞かれることがあり、責任者にディスプレイ方法の変更を提案したところ、来客数が増え、売上が前年比でアップすることがありました。この経験で得た客観的に判断する能力を活かしていきたいと考えています。'
        },
        {
          title: '自己PR',
          description:
            '私の長所は、コツコツと仕事を続けられる、継続力があるところです。大学で所属していたXXサークルの合宿は、部員全員の意見をまとめ、決定しています。私は100人以上いる部員の意見をまとめるために、アンケートを作成し、意見を聞き、集計していました。スケジュール管理も大変でしたが、全員の意見をまとめることがとても大変でした。この経験から、継続的な仕事を続けることができると考えております。'
        }
      ],
      // 資格
      license: licenseCommon,
      // 本人希望欄
      request: [
        {
          title: '連絡可能な時間帯',
          description:
            '連絡可能な時間帯：電話の場合、平日18時以降または土日祝日。現在在職中のため、平日日中のご連絡についてはメールでお送り頂ければ幸いです。'
        },
        {
          title: '帰社時間の希望',
          description:
            '子供の保育園の迎えのため、毎週水曜日は18時に退勤させていただければ幸いです。'
        },
        { title: '希望職種', description: '希望職種：XX職を希望します。' },
        { title: '勤務地の希望', description: '希望勤務地：XX店' },
        { title: '希望年収', description: '希望年収はXXX万円となります。' },
        { title: '特に希望がない場合', description: '貴社規定に従います。' }
      ]
    }
  }),
  new FormatItem({
    // 転職用の履歴書（JIS規格）
    id: 'part',
    title: 'アルバイト用のyagioffer登録',
    description:
      '令和２年７月からスタートした新様式です。日本工業規格（JIS）の規格に従ったA4サイズ2枚の一般的な履歴書テンプレートです。学歴・職歴の記入欄は比較的広めのつくりになっており、社会人経験が長い人にもおすすめです。',
    thumbnail: '/static/img/formats/rirekisho_job_change.png',
    images: [
      '/static/img/formats/sample/rirekisho_job_change_01.jpg',
      '/static/img/formats/sample/rirekisho_job_change_new_02.jpeg'
    ],
    newdetail1: 'A4サイズ/２枚',
    newdetail2: '令和２年７月からスタートした新様式',
    newdetail3: '社会人経験多めの方におすすめ',
    newdetail: '社会人経験多めの方向け',
    pagenumbs: '2枚',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email',
      'contact',
      'contactTel',
      'contactEmail',
      'photo'
    ],
    hashs: ['履歴書', '転職'],
    components: {
      edit: CareerYagiofferEdit
    },
    cards: CareerYagiofferCards,
    exampleSentences: jobChangeExampleSentences
  }),
  new FormatItem({
    // 転職用の履歴書（JIS規格）
    id: 'free',
    title: '複業用のyagioffer登録',
    description:
      '令和２年７月からスタートした新様式です。日本工業規格（JIS）の規格に従ったA4サイズ2枚の一般的な履歴書テンプレートです。学歴・職歴の記入欄は比較的広めのつくりになっており、社会人経験が長い人にもおすすめです。',
    thumbnail: '/static/img/formats/rirekisho_job_change.png',
    images: [
      '/static/img/formats/sample/rirekisho_job_change_01.jpg',
      '/static/img/formats/sample/rirekisho_job_change_new_02.jpeg'
    ],
    newdetail1: 'A4サイズ/２枚',
    newdetail2: '令和２年７月からスタートした新様式',
    newdetail3: '社会人経験多めの方におすすめ',
    newdetail: '社会人経験多めの方向け',
    pagenumbs: '2枚',
    requiredBasicFields: [
      'name',
      'furigana',
      'birth',
      'sex',
      'address',
      'addressFurigana',
      'tel',
      'email',
      'contact',
      'contactTel',
      'contactEmail',
      'photo'
    ],
    hashs: ['履歴書', '転職'],
    components: {
      edit: CareerYagiofferEdit
    },
    cards: CareerYagiofferCards,
    exampleSentences: jobChangeExampleSentences
  })
]

export default formatsIndex
